// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3WAw5","list":"BalanceDue_list__39xsw","listRow":"BalanceDue_listRow__JGFaC","total":"BalanceDue_total__1FwQ9"};